export const isSensitiveType = (type: string): boolean =>
  type === "string" || type === "address";
